import(/* webpackMode: "eager" */ "/tmp/ehky33rpg7pc/app/games/gomoku/page.tsx")